import { ModalCustom } from "components/ModalCustom";
import { ModalBody } from "./style";
import {
  ICustoAdicionar,
  IProcessoCriarLote,
} from "../../../../interface/IProcessosCriarLote";
import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { FaTrash } from "react-icons/fa";
import { InputValor } from "./InputValor";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  processoEditar: IProcessoCriarLote;
  setShowModalCertezaRemoverCusto: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setCustoRemoverProcesso: React.Dispatch<
    React.SetStateAction<ICustoAdicionar>
  >;
  setShowModalEditarCustos: React.Dispatch<React.SetStateAction<boolean>>;
  setProcessoEditar: React.Dispatch<React.SetStateAction<IProcessoCriarLote>>;
}

export function ModalEditarCustos({
  show,
  handleClose,
  onConfirm,
  processoEditar,
  setShowModalCertezaRemoverCusto,
  setCustoRemoverProcesso,
  setShowModalEditarCustos,
  setProcessoEditar,
}: IProps) {
  const onClickRemover = (custo: ICustoAdicionar) => {
    setCustoRemoverProcesso(custo);
    setShowModalEditarCustos(false);
    setShowModalCertezaRemoverCusto(true);
  };

  const atualizarValor = (idDescricao: number, valor: string) => {
    setProcessoEditar((processo) => {
      const novosCustos = processo.custos.map((custo) => {
        if (custo.idDescricao === idDescricao) {
          return { ...custo, valor };
        }
        return custo;
      });

      return { ...processo, custos: novosCustos };
    });
  };

  const columns: IColum<ICustoAdicionar>[] = [
    {
      name: "Custo",
      selector: ({ label }: ICustoAdicionar) => label,
      width: "300px",
    },
    {
      name: "Valor",
      selector: ({ valor, idDescricao }: ICustoAdicionar) => (
        <InputValor
          valor={valor}
          idDescricao={idDescricao}
          atualizarValor={atualizarValor}
        />
      ),
      width: "300px",
    },
    {
      name: "Ações",
      selector: (custo: ICustoAdicionar) => (
        <FaTrash
          onClick={() => onClickRemover(custo)}
          style={{ cursor: "pointer" }}
          title="Remover custo"
        />
      ),
    },
  ];

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={`Editar custos - Processo ${processoEditar.idProcesso}`}
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Salvar"
      disabledConfirmButton={processoEditar.custos.some(
        (custo) => !custo.valor || custo.valor === "0.00"
      )}
      size="lg"
    >
      <ModalBody>
        <Table
          keyField="idProcesso"
          columns={columns}
          data={processoEditar.custos}
          loading={false}
          noSubHeader
          possuiTooltip
        />
      </ModalBody>
    </ModalCustom>
  );
}
